export function MYOBSupport ($uibModal, sessionObjAPI) {
  var MYOBSupport = function() {};


  return MYOBSupport;
}